import { isDingdingMiniapp } from "../_utils/miniappEnvApp";
import { normalize } from "../common";
import { CONTAINER_NAME } from "../_utils/constant";
var removeSaved = normalize.removeSaved(function (options) {
  var filePath = options.filePath,
      _success = options.success,
      _fail = options.fail,
      _complete = options.complete;
  var removeSavedFile = isDingdingMiniapp ? dd.removeSavedFile : my.removeSavedFile;
  removeSavedFile({
    apFilePath: filePath,
    success: function success() {
      _success && _success();
    },
    fail: function fail(res) {
      _fail && _fail(res);
    },
    complete: function complete(res) {
      _complete && _complete(res);
    }
  });
}, CONTAINER_NAME.ALIPAY);
export default removeSaved;